<template>
  <div class="statistics">
    <div class="stat">
      Time in bed:
      <span class="stat-stat">{{ timeInBed(existingEntry.data) }}</span>
    </div>

    <div class="stat">
      Total Sleep time:
      <span class="stat-stat">{{ totalSleepTime(existingEntry.data) }}</span>
    </div>

    <div class="stat">
      Sleep efficiency:
      <span class="stat-stat">{{ sleepEfficiency(existingEntry.data) }}%</span>
    </div>

    <div class="stat">
      Sleep onset latency:
      <span class="stat-stat">{{ existingEntry.data.timeToSleep }}</span>
    </div>

    <div class="stat">
      Total duration of daytime naps:
      <span class="stat-stat">{{ existingEntry.data.awakeTime }}</span>
    </div>
  </div>
</template>

<script>
import Sleep from "../../../mixins/modules/sleep.js";

export default {
  name: "Stats",
  mixins: [Sleep],
  props: ["existingEntry"]
};
</script>

